import React from "react";
import styled from "styled-components";
import type { FlagIconInternalProps } from "./types";

const StyledFlagIcon = styled.div<{ $size: number }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: ${(props) => props.$size}px;
  height: ${(props) => props.$size}px;

  svg {
    width: 100%;
    height: 100%;
  }
`;

export const FlagIcon: React.FC<FlagIconInternalProps> = ({
  size = 24,
  svgContent,
  className,
  style,
  "data-testid": testId,
  testID,
  "aria-label": ariaLabel,
  "aria-hidden": ariaHidden,
}) => (
  <StyledFlagIcon
    $size={size}
    className={className}
    style={style}
    data-testid={testId || testID}
    role={ariaLabel ? "img" : undefined}
    aria-label={ariaLabel}
    aria-hidden={ariaHidden ?? (ariaLabel ? undefined : true)}
    dangerouslySetInnerHTML={{ __html: svgContent }}
  />
);
